import { h, Component } from 'preact';
import Store from 'store/store';
import { commaSeparatedList } from 'utils/utils';

import s from 'components/bolt/section/section.sss';

export default class Section extends Component {
	componentDidMount() {
		const appData = this.props.appData;
		const pageData = appData?.pages?.[this.props.id];
		if (appData?.options?.ageGate && pageData?.section) {
			import(/* webpackChunkName: "ageGate" */ 'components/bolt/ageGate/ageGate').then(component => {
				this.AgeGate = component.default;
				this.forceUpdate();
			});
		}

		if (pageData?.data?.bg) {
			import(/* webpackChunkName: "sectionBackground" */ 'components/bolt/sectionBackground/sectionBackground').then(component => {
				this.SectionBackground = component.default;
				this.forceUpdate();
			});
		}
	}
	shouldShowAgeGate() {
		const appData = this.props.appData;
		const data = this.props.appData?.options?.ageGate;
		const pageData = appData?.pages?.[this.props.id];
		if (!data || !pageData?.section || Store.get().ageGateOpen !== false) {
			return false;
		}
		const onlyOnPages = data?.onlyOnPages || '';
		return commaSeparatedList(onlyOnPages).includes(this.props.id);
	}

	renderBgContent() {
		const { appData, id } = this.props;
		const pageData = appData.pages[id]?.data;

		if (!this.SectionBackground || !pageData?.bg) {
			return;
		}
		return (
			<div class={s.contentBelow} key="bg"><this.SectionBackground ref={ref => this.sectionBackground = ref} data={pageData.bg} /></div>
		);
	}

	renderOverlayedContent() {
		const { appData } = this.props;

		if (this.AgeGate) {
			return (
				<div class={s.overlayedContent} key="overlay">
					{!!this.shouldShowAgeGate() && <this.AgeGate appData={appData} copy={appData.copy} key="ageGate" isSectionAgeGate />}
				</div>
			);
		}
	}
}